module.exports = __webpack_public_path__ + "static/SumoMe-e7608390a1323718defdaba1bcf0a4d0.png";